(function () {
	'use strict';

	const modules = [];

	angular.module('ProjectModule', modules);
})();
